module.exports = __webpack_public_path__ + "static/media/brand-logo.946ec118.svg";